import { useEffect,useState } from 'react'

import { vehiclesApi } from '@/api/vehicles.api'
import type { Vehicle } from '@/types/vehicle'

import { useDebounce } from './useDebounce'

export const useVehicles = (search: string, enabled = true) => {
  const [data, setData] = useState<Vehicle[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<any>(null)

  const debouncedSearch = useDebounce(search, 300)

  useEffect(() => {
    if (!enabled) return

    const fetchVehicles = async () => {
      setIsLoading(true)
      try {
        const response = await vehiclesApi.getVehicles({
          number: debouncedSearch,
          limit: 10
        })
        setData(response.Vehicles ?? [])
        setError(null)
      } catch (err) {
        setError(err)
      } finally {
        setIsLoading(false)
      }
    }

    fetchVehicles()
  }, [debouncedSearch, enabled])

  return { data, isLoading, error }
}
